import styled from 'styled-components';

export const BoardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
`;

export const ColumnHeader = styled.div`
  padding: 12px 16px;
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${({ $color }) => $color}15;
  border-bottom: 2px solid ${({ $color }) => $color};
`;

export const ColumnHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
`;

export const ColumnIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const ColumnTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #1d3557;
  margin: 0;
`;

export const ColumnCount = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  background: white;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 28px;
  text-align: center;
`;

export const ColumnCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #2d6cdf;
  flex-shrink: 0;
`;

export const CardsContainer = styled.div`
  padding: 16px;
  min-height: 400px;
  flex: 1;
  background: ${({ $isDraggingOver, $color }) =>
    $isDraggingOver ? `${$color}15` : `${$color}08`};
  transition: background 0.2s ease;
  border-radius: 0 0 12px 12px;
`;
